import type { ScreenWakeLockAdapter, ScreenWakeLockHandle } from "./types.js";

interface WebWakeLockSentinel extends EventTarget {
  release(): Promise<void>;
}

interface WebWakeLock {
  request(type: "screen"): Promise<WebWakeLockSentinel>;
}

interface WakeLockNavigator {
  readonly wakeLock?: WebWakeLock;
}

export function createWebScreenWakeLockAdapter(
  nav: WakeLockNavigator | undefined = typeof navigator === "undefined"
    ? undefined
    : (navigator as WakeLockNavigator),
): ScreenWakeLockAdapter {
  return {
    name: "web-screen-wake-lock",
    isSupported: () => typeof nav?.wakeLock?.request === "function",
    async request(): Promise<ScreenWakeLockHandle> {
      if (typeof nav?.wakeLock?.request !== "function") {
        throw new Error("Screen Wake Lock API is not supported");
      }
      const sentinel = await nav.wakeLock.request("screen");
      return {
        release: () => sentinel.release(),
        onRelease(listener) {
          sentinel.addEventListener("release", listener);
          return () => sentinel.removeEventListener("release", listener);
        },
      };
    },
  };
}
